<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
      @keydown.esc="closeDialog"
    >
      <v-toolbar fixed dark color="blue">
        <v-toolbar-title class="pl-3">Settlement</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <v-btn
            v-if="showDownload"
            icon
            :loading="loading"
            :disabled="loading"
            @click="downloadDialog"
            class="mr-3"
            slot="activator"
          >
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path
                fill="#ffffff"
                d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
              />
            </svg>
          </v-btn>
          <span>Download Excel File</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            v-if="!hideSave"
            icon
            :loading="loading"
            :disabled="loading || disableSave"
            @click="saveDialog"
            class="mr-3"
            slot="activator"
          >
            <v-icon>save</v-icon>
          </v-btn>
          <span>Save</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn icon @click.native="closeDialog()" class="mr-3" slot="activator">
            <v-icon>close</v-icon>
          </v-btn>
          <span>Close</span>
        </v-tooltip>
      </v-toolbar>
      <v-card style="position: absolute; top: 0; left: 0;">
        <v-card-text class="my-5 pa-4">
          <v-container fill-height v-if="loading">
            <v-layout align-center justify-center>
              <v-progress-circular :size="40" :width="3" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
          <slot v-else></slot>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    dialog: Boolean,
    type: String,
    loading: Boolean,
    disableSave: Boolean,
    hideSave: Boolean,
    showDownload: Boolean
  },
  data() {
    return {};
  },
  methods: {
    saveDialog() {
      this.$emit("saveDialog");
    },
    downloadDialog() {
      this.$emit("downloadDialog");
    },
    saveConfirmDialog() {
      this.$emit("saveConfirmDialog");
    },
    openDialog() {
      this.$emit("openDialog");
    },
    closeDialog() {
      this.$emit("closeDialog");
      //   this.$clearTempData();
    },
    closeConfirmDialog() {
      this.$emit("closeConfirmDialog");
    }
  }
};
</script>

<style>
</style>
